<template>
    <div id="workstation-product-overview-page">
        <product-overview
            endpoint="/product/overviewForWorkpost/"
            :extra-payload="extraPayload"
            :page-id="'workpost' + workpostTypeId">
            <template v-slot:actions>
                <actions-menu-item
                    :v4="true"
                    :action="() => $refs.workpostSelection.show()"
                    icon="camera"
                    :label="trans('pages.workstation_product_overview.start_camera')" />
            </template>
        </product-overview>
        <ui5-dialog ref="workpostSelection" :header-text="trans('pages.workstation_product_overview.select_workstation')">
            <div
                class="workstation-selection"
                v-if="workpostType && workpostType.workstations">
                <ui5-button
                    v-for="workstation in workpostType.workstations"
                    :key="'workstation.' + workstation.id"
                    @click="
                        $router.push('/workpostscanproduct/' + workstation.id)
                    ">
                    {{ workstation.label }}
                </ui5-button>
            </div>
            <div class="footer" slot="footer">
                <ui5-button @click="$refs.workpostSelection.close()">
                    {{ trans('pages.workstation_product_overview.close') }}
                </ui5-button>
            </div>
        </ui5-dialog>
    </div>
</template>
<script>
import ActionsMenuItem from '../components/ActionsMenuItem';
import ProductOverview from '../components/ProductOverview';
import workstationApi from '../api/workstation';
import { getToday } from '../helpers/DateHelper';
import localization from '../mixins/localization';

export default {
    components: { ProductOverview, ActionsMenuItem },
    mixins: [localization],
    data() {
        return {
            workpostType: null,
        };
    },
    computed: {
        workpostTypeId() {
            return this.$route.params.id;
        },
        extraPayload() {
            return { workpostTypeId: this.workpostTypeId, day: getToday() };
        },
    },
    mounted() {
        workstationApi
            .fetchTypeById(this.workpostTypeId, true)
            .then((response) => {
                this.workpostType = response.data.data;
                this.$store.commit(
                    'general/setPageTitle',
                    this.trans('pages.workstation_product_overview.products_for', { workstationName: this.workpostType.externalName })
                );
            });
    },
};
</script>
